// extracted by mini-css-extract-plugin
export var colorSquare = "_mw-0";
export var danger = "_mw-5";
export var lightPink = "_mw-8";
export var neutralBlue = "_mw-7";
export var neutralYellow = "_mw-6";
export var normal = "_mw-1";
export var primary = "_mw-2";
export var primaryLight = "_mw-3";
export var solidBlack = "_mw-g";
export var solidGreen = "_mw-b";
export var solidLightBlue = "_mw-d";
export var solidNavy = "_mw-c";
export var solidOrange = "_mw-f";
export var solidPink = "_mw-e";
export var solidRed = "_mw-9";
export var solidYellow = "_mw-a";
export var success = "_mw-4";